/**
 * Audio library
 *
 * Load and manage audio data from a single place. Allows for simpler reuse
 * across different game states.
 *
 * @type {Object}
 */
Game.Utils.Audio = {

	// Store the audio info.
	audio: [],


	/**
	 * Initialise the audio data.
	 *
	 * Ensures all of the game audio is assigned to a variable to be used.
	 * Also sets base audio properties (like default volumes).
	 */
	init: function() {

		// Don't reinitialize audio effects if they have already been set.
		if ( this.audio.length > 0 ) {
			return;
		}

		// Load all the things!
		// They get put in the audio array for easy access in the other functions.
		// The array is public so can also be accessed directly through: Game.Utils.Audio.audio['key']
		this.audio[ 'wind' ] = game.add.audio( 'wind' );
		this.audio[ 'menu' ] = game.add.audio( 'menu' );
		this.audio[ 'theme' ] = game.add.audio( 'theme' );
		this.audio[ 'splash' ] = game.add.audio( 'splash' );
		this.audio[ 'turn' ] = game.add.audio( 'ski-turn' );
		this.audio[ 'win' ] = game.add.audio( 'win' );
		this.audio[ 'lose' ] = game.add.audio( 'lose' );
		this.audio[ 'countdown' ] = game.add.audio( 'countdown' );

		this.audio[ 'weeeee' ] = game.add.audio( 'weeeeee' );
		this.audio[ 'weeeee' ].volume = 0.8;

		this.audio[ 'jump' ] = game.add.audio( 'jump-land' );
		this.audio[ 'jump' ].volume = 1.5;

		this.audio[ 'crash' ] = game.add.audio( 'crash' );
		this.audio[ 'crash' ].volume = 1.5;

	},


	/**
	 * Play the specified audio effect on a loop.
	 *
	 * @param  {string} effect The key for the audio effect to loop.
	 */
	play_loop: function( effect ) {

		return;

		if ( Game.debug ) {
			console.log( 'Audio loop: ' + effect );
		}

		this.audio[ effect ].loopFull();

	},


	/**
	 * Play a sound effect.
	 *
	 * @param  {string} audio The key for the audio effect to play.
	 */
	play: function( audio ) {

		return;

		this.audio[ audio ].play();

	},


	/**
	 * Fade out a sound effect.
	 *
	 * @param  {string} audio The key for the audio effect to fade out.
	 */
	fade_out: function( audio ) {

		return;

		this.audio[ audio ].fadeOut();

	},


	/**
	 * Fade in a sound effect.
	 *
	 * @param  {string}  audio    The key for the effect to fade in.
	 * @param  {Number}  duration The duration of the fade.
	 * @param  {Boolean} loop     Whether the effect should loop after fading in. Defaults to looping.
	 */
	fade_in: function( audio, duration, loop ) {

		return;

		if ( ! duration ) {
			duration = 1000;
		}

		if ( ! loop ) {
			loop = true;
		}

		this.audio[ audio ].fadeIn( duration, loop );

	},

}
